export const typeOfMolecularModal = 'typeOfMolecularModal';
export const molecularModalReducerKey = 'molecularModalReducerKey';
export const RESET_STATE = 'RESET_STATE';
export const UPDATE_STATE_PARAMS = 'UPDATE_STATE_PARAMS';
export const INITIALIZE_MOLECULAR_DATA = 'INITIALIZE_MOLECULAR_DATA';
